
import { useMemo } from "react";

export const usePlaylistsFormatter = (playlistsData: any[] | undefined) => {
  return useMemo(() => {
    if (!playlistsData) return [];
    
    console.log("usePlaylistsFormatter - Input data:", 
      playlistsData.map(p => ({id: p.id, name: p.name, created_at: p.created_at})));
    
    const formatted = playlistsData.map(playlist => ({
      id: playlist.id,
      name: playlist.name,
      channelName: playlist.channels?.name || '',
      thumbnailUrl: playlist.thumbnail,
      count: 0
    }));
    
    console.log("usePlaylistsFormatter - Formatted output:", 
      formatted.map(p => ({id: p.id, name: p.name})));
      
    return formatted;
  }, [playlistsData]);
};
